import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-apply_to_sell_on_faire-click';

/**
 * parameter indicates the position of the apply button clicked. Should be one of the following: &quot;top-section&quot;, &quot;sticky-banner&quot;, &quot;bottom-section&quot;
 */
export function trackBrandLeadsApplyToSellOnFaireClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { customParameterToken },
  });
}
